import script from "./MobSpecialAbilities.vue?vue&type=script&setup=true&lang=js"
export * from "./MobSpecialAbilities.vue?vue&type=script&setup=true&lang=js"

import "./MobSpecialAbilities.vue?vue&type=style&index=0&id=11734e78&lang=css"

const __exports__ = script;

export default __exports__